import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import runtime from './runtime';
import intl from './intl';
import license from './license';
import user from './user';

export default combineReducers({
  runtime,
  intl,
  license,
  user,
  form: formReducer,
});
